import * as Sentry from '@sentry/vue'

import type { App } from 'vue'

export const setupSentry = (app: App): void => {
  if (
    import.meta.env.MODE === 'development' ||
    import.meta.env.MODE === 'test'
  ) {
    return
  }
  Sentry.init({
    app,
    dist: import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.dist,
    release: import.meta.env.VITE_PLUGIN_SENTRY_CONFIG.release,
    dsn: 'https://081bc1b5bf5a41a1995adfd2dba5c3c6@o161939.ingest.sentry.io/5379333',
    integrations: [
      Sentry.dedupeIntegration(),
      Sentry.globalHandlersIntegration({
        onerror: true,
        onunhandledrejection: true,
      }),
      Sentry.extraErrorDataIntegration({ depth: 5 }),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    beforeSend: event => {
      console.info({ event })
      return event
    },
    environment: import.meta.env.MODE,
    denyUrls: [
      /googletagmanager\.com/i,
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // local file
      /^file:\/\//i,
    ],
    ignoreErrors: [
      /Unauthorized/,
      // 401
      /Received status code 401/,
      /Request failed with status code 401/,
      /Response not successful: Received status code 401/,
      // Timeout
      /timeout/,
      // Network error
      /Network Error/,
      /Failed to fetch/,
      /Load failed/,
      /Request aborted/,
      /socket is not opened/,
      // 謎の拡張エラー
      /learningToolsRuntimeBridge/,
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production -> 5% now
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.05 : 0,

    // disable entire session capturing
    replaysSessionSampleRate: 0,
    // Capture Replay for 100% of error sessions
    replaysOnErrorSampleRate: 1.0,
  })
}

export const trackSession = (longSessionId: string): void =>
  Sentry.setTag('long_session_id', longSessionId)
export const trackPlanner = (user: { id: string; username: string }): void =>
  Sentry.setUser(user)
export const unsetTrackingPlanner = (): void => Sentry.setUser(null)
export const trackErrorOperation = (
  gqlOperation: string,
  gqlVariables: string,
  gqlResponse: string,
  gqlErrors: string
): void =>
  Sentry.setExtras({
    gqlOperation,
    gqlVariables,
    gqlResponse,
    gqlErrors,
  })
